import {
  Component,
  Input,
  OnInit,
  ViewChildren,
  QueryList,
  ElementRef,
  AfterViewInit,
} from '@angular/core';
import { OffersOfApplication } from '../../../../type/result_type';
import { FocusManagementService } from '../../../../service/focus-management.service';
import { DownloadStateService } from '../../../../service/download-state.service';

@Component({
  selector: 'app-product',
  templateUrl: './product.component.html',
  styleUrls: ['./product.component.scss'],
})
export class ProductComponent implements OnInit, AfterViewInit {
  @Input() productData!: OffersOfApplication;
  @Input() focusParentTab: () => void; // Function to focus parent tab
  @ViewChildren('focusableContent') focusableContents!: QueryList<ElementRef>;

  public hint = [
    {
      title: 'Lorem Ipsum',
      text: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry.',
    },
  ];

  constructor(
    private focusManagementService: FocusManagementService,
    public downloadStateService: DownloadStateService
  ) {}

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    this.focusManagementService.setupKeydownListeners(
      this.focusableContents,
      this.focusParentTab
    );
  }

  onDownloadClick(): void {
    this.downloadStateService.setDownloading(this.productData.id);

    fetch(`/contract-download/${this.productData.contractToken}`)
      .then(response => {
        console.log('Fetch response received:', response.status);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.blob();
      })
      .then(blob => {
        console.log('Blob received, size:', blob.size);
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `contract-${this.productData.id}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);

        this.downloadStateService.cleanup(this.productData.id);
      })
      .catch(error => {
        console.error('Download failed:', error);
        this.downloadStateService.cleanup(this.productData.id);
      });
  }
}
